import type { ColumnDef } from '@tanstack/react-table';

import { type GetProductsWithRecipesQuery } from 'data/__generated__';
import { textColumn, numberColumn } from 'components/DataTable';

export type HotDrinksRecipeRow = GetProductsWithRecipesQuery['getAllProducts'][number];

type HotDrinksRecipeFilterInput = {
    searchValue: string;
};

export const hotDrinksRecipesColumns: ColumnDef<HotDrinksRecipeRow, unknown>[] = [
    textColumn<HotDrinksRecipeRow, HotDrinksRecipeFilterInput>({
        accessorKey: '_id',
        header: 'Identifiant unique',
        defaultVisible: true,
    }),
    textColumn<HotDrinksRecipeRow, HotDrinksRecipeFilterInput>({
        accessorKey: 'fullname',
        header: 'Produit',
        defaultVisible: true,
    }),
    numberColumn<HotDrinksRecipeRow, HotDrinksRecipeFilterInput>({
        accessorKey: 'recipe',
        header: "Nombre d'ingrédients",
        defaultVisible: true,
        cell: ({ row }) => row.original.recipe?.ingredients.length ?? 0,
    }),
];
